import { CLASE_ESTADO_CONSULTA, ETIQUETA_ESTADO_CONSULTA, EstadoConsulta } from '../../utils/consultas';

/**
 * Badge de estado de una consulta ("Enviada", "Respondida", "Cerrada"). Lo usan el
 * partido (#388) y la SEP (#390). Con `recibida`, el partido ve "Recibida": una
 * consulta que le inició la Secretaría y que todavía no contestó.
 */
export default function EstadoConsultaBadge({ estado, recibida = false }: { estado: EstadoConsulta; recibida?: boolean }) {
  if (recibida && estado === 'RESPONDIDA') {
    return (
      <span className="inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium bg-amber-100 text-amber-800">
        Recibida
      </span>
    );
  }
  return (
    <span className={`inline-flex items-center rounded-full px-2.5 py-0.5 text-xs font-medium ${CLASE_ESTADO_CONSULTA[estado] ?? 'bg-gray-100 text-gray-700'}`}>
      {ETIQUETA_ESTADO_CONSULTA[estado] ?? estado}
    </span>
  );
}
